import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './Stack.module.css';

export type StackGap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8;

export interface StackProps {
  readonly direction?: 'column' | 'row' | undefined;
  readonly gap?: StackGap | undefined;
  readonly align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline' | undefined;
  readonly justify?: 'start' | 'center' | 'end' | 'between' | undefined;
  readonly wrap?: boolean | undefined;
  readonly as?: 'div' | 'section' | 'ul' | 'ol' | 'form' | undefined;
  readonly className?: string | undefined;
  readonly children: ReactNode;
}

/** Flex layout on the spacing scale, so screens do not hand-roll spacing. */
export const Stack = ({
  direction = 'column',
  gap = 4,
  align,
  justify,
  wrap,
  as: Element = 'div',
  className,
  children,
}: StackProps) => (
  <Element
    className={clsx(
      styles.stack,
      styles[direction],
      styles[`gap${gap}`],
      align && styles[`align-${align}`],
      justify && styles[`justify-${justify}`],
      wrap && styles.wrap,
      className,
    )}
  >
    {children}
  </Element>
);
